import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const findAllMinaReceipt = createAsyncThunk(
  "MinaReceipt/FindAllMinaReceipt",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MinaReceipt/FindAllMinaReceipt`,
        formData
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Mina Receipt", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createMinaReceipt = createAsyncThunk(
  "MinaReceipt/InsertMinaReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MinaReceipt/InsertMinaReceipt`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Mina Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateMinaReceipt = createAsyncThunk(
  "MinaReceipt/UpdateMinaReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MinaReceipt/UpdateMinaReceipt`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Mina Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteMinaReceipt = createAsyncThunk(
  "MinaReceipt/DeleteMinaReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MinaReceipt/DeleteMinaReceipt`,
        { mina_receipt_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Mina Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getMinaReceiptById = createAsyncThunk(
  "MinaReceipt/FindByIDMinaReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MinaReceipt/FindByIDMinaReceipt`,
        { mina_receipt_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        mina_receipt_guid: result.mina_receipt_guid,
        mina_receipt_no: result.mina_receipt_no,
        receipt_date: result.receipt_date
          ? moment(result.receipt_date).toDate()
          : "",

        karigar_id: result.karigar_id,
        karigar_name: result.karigar_name,
        karigar_nick_name: result.karigar_nick_name,
        charges: result.charges,
        gold_rate: result.gold_rate,
        mina_receipt_order: result?.mina_receipt_order,
        karigarIdWiseOutStandingAmount: result?.karigarIdWiseOutStandingAmount,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Mina Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteMinaReceiptOrderItems = createAsyncThunk(
  "MinaReceipt/DeleteMinaReceiptOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MinaReceipt/DeleteMinaReceiptOrder`,
        { id: ID }
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Mina Receipt Order item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateMinaReceiptImage = createAsyncThunk(
  "MinaReceipt/MinaReceiptImageUpdate",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MinaReceipt/MinaReceiptImageUpdate`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Mina Receipt Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findAllPendingMinaOrder = createAsyncThunk(
  "MinaReceipt/MinaPendingOrderList",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MinaReceipt/MinaPendingOrderList`,
        formData
      );

      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Mina Receipt", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
